/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React, {useEffect, useState} from 'react';
// import { Link } from 'react-router-dom';
import {withTranslation} from 'react-i18next';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import {LazyLoadImage} from "react-lazy-load-image-component";

import {Grid, FormGroup, CardContent, Typography} from '@material-ui/core';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';

import {useQuery, useMutation} from '@apollo/client';
import {GET_CATEGORY_WITH_PRODUCTS, ADD_TO_CART, GET_SHOPPINGCART} from '../../queries';
import PhotoFilterComponent from '../Photo/PhotoFilterComponent';
import {useThemeData} from '../../context/ThemeDataContext'
import {usePhotoBaseData} from '../../context/PhotoBasicDataContext'
// import {useAuthData} from '../../context/AuthProvider'
import GeneralButton from "../Buttons";
import GeneralText from "../Fonts";
import ProductPrice from "../ProductPrice";
import loadImage from "../../loader.svg";
const PRODUCT_URL = process.env.REACT_APP_PRODUCT_URL;

function ExtraProducts(props) {
    const responsive = {
        desktop: {
            breakpoint: {max: 3000, min: 1024},
            items: 6,
            slidesToSlide: 1 // optional, default to 1.
        },
        tablet: {
            breakpoint: {max: 1024, min: 464},
            items: 3,
            slidesToSlide: 1 // optional, default to 1.
        },
        mobile: {
            breakpoint: {max: 464, min: 0},
            items: 1,
            slidesToSlide: 1 // optional, default to 1.
        }
    };
    // const {kassakoopjes} = useThemeData().modules;
    // const APP_URL = process.env.REACT_APP_SITE_URL;
    const {site_id} = useThemeData().themeData.site;
    const {border_radius_2, primary_color_2, primary_color_3, primary_color_5,background_color_3, background_color_4, background_color_7} = useThemeData().themeData.site.theme;
    // const {auth} = useAuthData();
    const {photoData} = usePhotoBaseData();
    // const PHOTO_URL = process.env.REACT_APP_PHOTO_URL;
    const login = localStorage.getItem("login_name");
    const firstPartLogin = login !== null ? login.replace('["', "") : "";
    const MiddelPartLogin = firstPartLogin.replace('","', ", ");
    const login_name = MiddelPartLogin.replace('"]', "");
    const [logins] = useState({login_name});
    const session_id = localStorage.getItem('session_id');

    const [products, setProducts] = useState([]);
    const [photos, setPhotos] = useState({id: '', file_name: '', folder_id: ''});
    const [data, setData] = useState([]);

    const {loading: loadingCategories, error: errorCategories, data: dataCategories} =
        useQuery(GET_CATEGORY_WITH_PRODUCTS, {
            variables: {
                bargains: 1,
                site_id: site_id
            },
            // skip: !auth || !site_id || (kassakoopjes !== true && kassakoopjes !== 1)
        });

    const [createShoppingcart,
        {loading: loadingCreateShoppingCart, error: errorCreateShoppingCart}]
        = useMutation(ADD_TO_CART, {
            onCompleted: (data) => {
                console.log('hahah')
            },
            onError: (error) => {

            },
            refetchQueries: [{
                query: GET_SHOPPINGCART,
                variables: {
                    session_id: session_id,
                    site_id: site_id,
                    login_name: [logins]
                }
            }],
        }
    );

    useEffect(() => {
        if (!loadingCategories && !errorCategories && dataCategories) {
            if (dataCategories.productcategorybybargains) {
                setData(dataCategories.productcategorybybargains.catproducts);
            }
        }
    }, [dataCategories, errorCategories, loadingCategories])

    useEffect(() => {
        if (products.length < 1 && data.length > 0 && photoData.length > 0) {
            let newPhotos = new Set();
            let newProds = new Set();

            photoData.filter((photo, index) => {
                let array = {
                    id: photo.id,
                    file_name: photo.file_name,
                    folder_id: photo.folder.folder_id,
                    folder: photo.folder,
                    productcategory: photo.productcategory,
                }
                return newPhotos.add(array);
            })
            let itemphotos = Array.from(newPhotos);
            setPhotos({id: itemphotos[0].id, file_name: itemphotos[0].file_name, folder_id: itemphotos[0].folder_id});

            data.filter((c) => {
                let array = {
                    product_id: c.product_id,
                    naam: c.naam,
                    product_file: c.product_file,
                    product_format: c.formaat,
                    actie_afbeelding: c.actie_afbeelding,
                    actie_begin_datum: c.actie_begin_datum,
                    actie_eind_datum: c.actie_eind_datum,
                    actie_prijs: c.actie_prijs,
                    afbeelding: c.afbeelding,
                    description: c.description,
                    kleuren: c.kleuren,
                    prijs: c.prijs,
                    product_type: c.product_type,
                    shippingcost: c.verzendkosten,
                    youtube: c.youtube,
                    photos: itemphotos
                }
                return newProds.add(array);
            })
            let itemproducts = Array.from(newProds);
            setProducts(itemproducts);
        }
    }, [data, photoData, products.length])


    const updatePhotoFileName = (newPhotoFileName, productIndex, product_child_id, photoid, photoIndex, z, folder_id) => {
        let newProduct = new Set(); //pakketdetails
        let newPhotos = new Set();

        products.map((c, indexId) => {
            if (productIndex === c.product_id) {
                c.photos.map((p, i) => {
                    if (i === photoIndex) {
                        let array = {
                            id: photoid,
                            folder_id: folder_id,
                            file_name: newPhotoFileName,
                            folder: p.folder,
                            productcategory: p.productcategory,
                        }

                        setPhotos({id: folder_id, file_name: newPhotoFileName, folder_id: folder_id});

                        return newPhotos.add(array);
                    } else {
                        let array = {
                            id: photoid,
                            file_name: newPhotoFileName,
                            folder: p.folder,
                            folder_id: folder_id,
                            productcategory: p.productcategory,
                        }

                        setPhotos({id: photoid, file_name: newPhotoFileName, folder_id: folder_id});

                        return newPhotos.add(array);
                    }
                })
            }
            let itemphotos = Array.from(newPhotos);


            let data_array = {
                product_id: c.product_id,
                naam: c.naam,
                product_file: c.product_file,
                product_format: c.product_format,
                actie_afbeelding: c.actie_afbeelding,
                actie_begin_datum: c.actie_begin_datum,
                actie_eind_datum: c.actie_eind_datum,
                actie_prijs: c.actie_prijs,
                afbeelding: c.afbeelding,
                description: c.description,
                kleuren: c.kleuren,
                prijs: c.prijs,
                product_type: c.product_type,
                shippingcost: c.shippingcost,
                youtube: c.youtube,
                photos: itemphotos
            };

            return newProduct.add(data_array);
        })
        let product = Array.from(newProduct);
        setProducts(product);
    }

    const onSubmit = (e, product, index) => {
        e.preventDefault();
        e.stopPropagation();

        //console.log(product);

        const newData = [{
            site_id: site_id,
            login_name: login_name,
            product_id: product.product_id,
            product_name: product.naam,
            product_file: photos.file_name,
            product_format: product.product_format,
            product_categorie: dataCategories.productcategorybybargains.naam,
            shippingcost: product.shippingcost,
            photo_id: photos.id,
            effect_file_name: null,
            totaalprijs: product.actie_prijs,
            oorspronkelijke_prijs_ps: product.prijs,
            prijs_ps: product.actie_prijs,
            session_id: session_id,
            image_effect: 'kleur',
            amount: 1,
            shoppingcart_rules: []
        }]
        if (!loadingCreateShoppingCart && !errorCreateShoppingCart) {
            createShoppingcart({
                variables: {
                    input: newData
                }
            })
        }
    }

    if (errorCategories || loadingCategories || !dataCategories) return null;

    return (
        products.length > 0 &&
        <Grid item xs={12} md={12} lg={12} xl={12} className="bottom-card">
            <Grid container direction="row" className="bottom-card">
                <GeneralText
                    style={{color: `${primary_color_2}`}}
                    variant="h5"
                    className="text-start"
                    gutterBottom={true}
                >
                    {props.t(`extraProducts:${dataCategories.productcategorybybargains.naam}`)}
                </GeneralText>
            </Grid>
            <Grid item xs={12} md={12} lg={12} xl={12}>
                <Carousel
                    swipeable={true}
                    draggable={true}
                    showDots={false}
                    responsive={responsive}
                    ssr={true} // means to render carousel on server-side.
                    infinite={true}
                    autoPlay={false}
                    autoPlaySpeed={5000}
                    keyBoardControl={true}
                    transitionDuration={500}
                    containerClass="carousel-container"
                    arrows={true}
                    deviceType={props.deviceType}
                    centerMode={true}
                >
                    {/* {data && data.map(data => { */}
                    {products && products.map((p, index) => {
                        return (
                            <FormGroup
                                key={index}
                                style={{
                                    border: `1px solid ${background_color_7}`,
                                    borderRadius: `${border_radius_2} ${border_radius_2} ${border_radius_2} ${border_radius_2}`,
                                    margin: '1rem',
                                    minHeight: '336px'
                                }} className="bottom-card">
                                <Grid item xs={12} md={12} lg={12} xl={12} style={{
                                    border: `1px solid ${background_color_7}`,
                                    backgroundColor: `${background_color_7}`,
                                    maxHeight: '48px',
                                    borderRadius: `${border_radius_2} ${border_radius_2} 0px 0px`
                                }} className="bottom-card card-header">
                                    <Grid container direction="row" className="no-full-margin-around">
                                        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}
                                              className="text-start"
                                              style={{
                                                      backgroundColor: `${background_color_3}`,
                                                      color: `${primary_color_3}`,
                                                      borderRadius: `${border_radius_2} ${border_radius_2} 0px 0px`
                                                  }}
                                        >
                                            <CardContent className="card-heading" style={{ padding:`5px` }}>
                                                <Typography className="font-bold" variant="subtitle1"
                                                            component="div"
                                                            style={{
                                                    // fontSize: `20px`
                                                                overflow: `hidden`,
                                                                maxHeight: `25px`
                                                }}>
                                                    {p.naam}
                                                </Typography>
                                            </CardContent>
                                        </Grid>

                                        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}
                                              className="text-end"
                                              style={{
                                                  backgroundColor: `${background_color_4}`,
                                                  color: `${primary_color_5}`

                                              }}
                                        >
                                            <CardContent className="card-heading priceBargains" style={{ padding:`5px` }}>
                                                <div>
                                                    <ProductPrice  price={p.prijs}
                                                                  actionprice={p.actie_prijs}></ProductPrice>
                                                </div>
                                            </CardContent>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                {p.afbeelding ? (
                                    <Grid item xs={12} md={12} lg={12} xl={12} className="bottom-card card-body"
                                          style={{maxWidth: '266px'}}>
                                        <Grid container direction="row">
                                            <Grid item xs={p.product_type === 'divers' ? 12 : 6}
                                                  xl={p.product_type === 'divers' ? 12 : 6}
                                                  lg={p.product_type === 'divers' ? 12 : 6}
                                                  md={p.product_type  === 'divers' ? 12 : 6}
                                                  sm={p.product_type  === 'divers' ? 12 : 12} className="product_file">
                                                <LazyLoadImage
                                                    src={`${PRODUCT_URL}${site_id}/${photos.id}/${p.product_id}/${p.afbeelding}`}
                                                    alt={props.product_image}
                                                    className="img-sizing product_afbeelding filter2"
                                                    placeholderSrc={loadImage}
                                                />
                                            </Grid>
                                            {p.product_type !== 'divers' && (
                                                <Grid item xs={12} xl={6} lg={6} md={6} sm={12} className="photo_file"
                                                      style={{ paddingLeft: '0rem', paddingRight: '0rem', maxWidth: '266px', height: '213px', maxHeight: '255px' }}>
                                                    <PhotoFilterComponent
                                                        {...props}
                                                        type='extra_products'
                                                        photos={p.photos}
                                                        product_child_id={0}
                                                        product_id={p.product_id}
                                                        folder_id={photos.folder_id}
                                                        photo_id={photos.id}
                                                        photo_file_name={photos.file_name}
                                                        Index={props.index}
                                                        updatePhotoFileName={updatePhotoFileName}
                                                    />
                                                </Grid>
                                            )}
                                        </Grid>
                                    </Grid>
                                ) : (
                                    <Grid item xs={12} md={12} lg={12} xl={12} className="bottom-card card-body"
                                          style={{maxWidth: '266px', height: '213px', maxHeight: '255px'}}>
                                        <PhotoFilterComponent
                                            {...props}
                                            type='extra_products'
                                            photos={p.photos}
                                            product_id={p.product_id}
                                            product_child_id={0}
                                            folder_id={photos.folder_id}
                                            photo_id={photos.id}
                                            photo_file_name={photos.file_name}
                                            Index={index}
                                            updatePhotoFileName={updatePhotoFileName}
                                        />
                                    </Grid>
                                )}
                                <Grid item xs={12} md={12} lg={12} xl={12} className="bottom-card card-footer">
                                    <GeneralButton
                                        type="button" // Note: Changed from "submit" to "button"
                                        name="addToCart"
                                        className="btn btn-secondary btn-bargains width-fill"
                                        endIcon={<AddShoppingCartIcon color="inherit"/>}
                                        onClick={(e) => onSubmit(e, p, index)} // Add onClick here instead of onSubmit on FormGroup
                                    >
                                        {props.t('shoppage:Add')}
                                    </GeneralButton>

                                </Grid>
                            </FormGroup>
                        )
                    })
                    }
                </Carousel>
            </Grid>
        </Grid>
    );
}

    export default React.memo(withTranslation('message')(ExtraProducts));
